import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { paths } from '@/route-path/routes';

// Home page (currently in App.tsx)
import App from '@/App';

// Page components
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import Search from '@/pages/Search';

// Lazy-loaded route components
const News = React.lazy(() => import('@/pages/news/News'));
const NewsNotices = React.lazy(() => import('@/pages/news/NewsNotices'));
const NewsDecisions = React.lazy(() => import('@/pages/news/NewsDecisions'));
const NewsResearch = React.lazy(() => import('@/pages/news/NewsResearch'));
const NewsArticle = React.lazy(() => import('@/pages/news/NewsCategoryArticle'));

const Research = React.lazy(() => import('@/pages/research/Research'));
const ResearchPolicy = React.lazy(() => import('@/pages/research/ResearchPolicy'));
const ResearchEducation = React.lazy(() => import('@/pages/research/ResearchEducation'));
const ResearchArticle = React.lazy(() => import('@/pages/research/ResearchCategoryArticle'));

const Skills = React.lazy(() => import('@/pages/skill/Skills'));
const SkillArticle = React.lazy(() => import('@/pages/skill/SkillArticle'));

const Policies = React.lazy(() => import('@/pages/policies/Policies'));
const PolicyArticle = React.lazy(() => import('@/pages/policies/PoliciesArticle'));

const Certificate = React.lazy(() => import('@/pages/certificate/Certificates'));
const CertificateResult = React.lazy(() => import('@/pages/certificate/CertificateResult'));

// Loading component for lazy-loaded routes
const Loading = () => <div>Loading...</div>;

// Router configuration
const router = createBrowserRouter([
  {
    path: paths.home,
    element: <App />
  },
  {
    path: paths.about,
    element: <About />
  },
  {
    path: paths.contact,
    element: <Contact />
  },
  {
    path: paths.search,
    element: <Search />
  },
  // News routes
  {
    path: paths.news,
    element: (
      <React.Suspense fallback={<Loading />}>
        <News />
      </React.Suspense>
    )
  },{
    path: paths.newsArticle,
    element: (
      <React.Suspense fallback={<Loading />}>
        <NewsArticle />
      </React.Suspense>
    )
  },
  {
    path: paths.newsNotices,
    element: (
      <React.Suspense fallback={<Loading />}>
        <NewsNotices />
      </React.Suspense>
    )
  },
  {
    path: paths.newsDecisions,
    element: (
      <React.Suspense fallback={<Loading />}>
        <NewsDecisions />
      </React.Suspense>
    )
  },
  {
    path: paths.newsResearch,
    element: (
      <React.Suspense fallback={<Loading />}>
        <NewsResearch />
      </React.Suspense>
    )
  },
  {
    path: paths.newsCategoryArticle,
    element: (
        <React.Suspense fallback={<Loading />}>
          <NewsArticle />
        </React.Suspense>
    )
  },
  // Research routes
  {
    path: paths.research,
    element: (
        <React.Suspense fallback={<Loading />}>
          <Research />
        </React.Suspense>
    )
  },
  {
    path: paths.researchArticle,
    element: (
      <React.Suspense fallback={<Loading />}>
        <ResearchArticle />
      </React.Suspense>
    )
  },
  {
    path: paths.researchPolicy,
    element: (
      <React.Suspense fallback={<Loading />}>
        <ResearchPolicy />
      </React.Suspense>
    )
  },
  {
    path: paths.researchEducation,
    element: (
      <React.Suspense fallback={<Loading />}>
        <ResearchEducation />
      </React.Suspense>
    )
  },
  {
    path: paths.researchCategoryArticle,
    element: (
      <React.Suspense fallback={<Loading />}>
        <ResearchArticle />
      </React.Suspense>
    )
  },
  // Skills routes
  {
    path: paths.skills,
    element: (
      <React.Suspense fallback={<Loading />}>
        <Skills />
      </React.Suspense>
    )
  },
  {
    path: paths.skill,
    element: (
      <React.Suspense fallback={<Loading />}>
        <SkillArticle />
      </React.Suspense>
    )
  },
  // Policies routes
  {
    path: paths.policies,
    element: (
      <React.Suspense fallback={<Loading />}>
        <Policies />
      </React.Suspense>
    )
  },
  {
    path: paths.policy,
    element: (
      <React.Suspense fallback={<Loading />}>
        <PolicyArticle />
      </React.Suspense>
    )
  },
  // Certificate routes
  {
    path: paths.certificates,
    element: (
      <React.Suspense fallback={<Loading />}>
        <Certificate />
      </React.Suspense>
    )
  },
  {
    path: paths.certificateResult,
    element: (
      <React.Suspense fallback={<Loading />}>
        <CertificateResult />
      </React.Suspense>
    )
  },
  // 404 route
  {
    path: '*',
    element: <div>404 - Page Not Found</div>
  }
]);

const Router = () => {
  return <RouterProvider router={router} />;
};

export default Router; 